<template>
  <div class="bg-lightGray mainPad">
    <div class="container">
      <b-alert class="row mt-2" variant="success" :show="showDismissibleAlert" style="width:89%;" dismissible><p>Your job has been posted successfully, it will be active within the next 24 hours</p></b-alert>
      <div class="row">
        <div>
          <nav area-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="/recruit">Home</a></li>
              <li class="breadcrumb-item"><a href="/recruit/client-job-dashboard">Dashboard</a></li>
              <li class="breadcrumb-item active" aria-current="page">Questionnaire</li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="row">
        <div class="questionnnaireBlock mobLRpad">
          <div>
            <h4><b>Add Questionnaire</b></h4>
            <p class="mb-1" style="color:#787878;">You can add relevant screening questions to this job.</p>
            <p class="innersubtxt" style="color:#787878;" >These questions will ask while the candidates are applying for the job. You can pre-screen matching candidates based on their answers.</p>
          </div>
          <div v-if="!loading">
            <!-- <h6 class="mt-5"><b>Add your questions here</b></h6> -->
            <div class="selected_questions mb-4" v-if="selectedQuestions.length" >
              <div v-for="(ques,index) in selectedQuestions" :key="index" >
                <div v-if="ques.question_flag == 1" class="questionnaire">
                  <div class="questionbx">
                    <h6>{{index+1}}. {{ques.question}}</h6>
                    <span class="float-right my-auto" @click="showDeleteConfirmation(ques.qid, index)"><h5><i class="mdi mdi-delete text-danger" v-b-tooltip.hover title="Delete"></i></h5></span>
                    <!-- <span v-on:click="deleteQuestion(index)" class="btn btn-secondary" style="float:right !important;cursor:pointer !important;">delete</span> -->
                    <div style="cursor:pointer" v-if="ques.show" v-on:click="showDropDownList(index)">
                      <div v-if="dropdown == 'show_drop_list_'+index" class="dropdown dropdown_more">
                        <div class="dropdown-list">
                          <div class="dropdown-content"  @click="deleteQuestion(index)"><button><strong>Delete</strong></button></div>
                        </div>
                      </div>
                      <div class="dot-icon">
                        <span class="material-icons">more_vert</span>
                      </div>
                    </div>
                  </div>
                  <div class="answer" v-if="ques.question_type == 4">
                    <v-radio-group v-model="ques.correct" style="margin-top:0px !important;">
                      <v-radio v-for="(answer,ans_index) in ques.answers" :key="ans_index" :label="answer.answer" :value="answer.ans_id"></v-radio>
                    </v-radio-group>
                  </div>
                  <div class="mt-2 inputStyle answer" v-if="ques.question_type == 5 && ques.autocomplete == false">
                    <v-autocomplete v-model="ques.correct" :items="ques.items" item-text="text" item-value="value" multiple @change="selectAnswer(ques.correct,ques)" outlined chips deletable-chips></v-autocomplete>
                  </div>
                  <div class="mt-2 inputStyle answer" v-if="ques.question_type ==5 && ques.autocomplete == true">
                    <div v-if="ques.qp_id == 5">
                      <v-autocomplete v-model="city" :items="cities" item-text="text" item-value="id" label="Select city" clearable outlined chips deletable-chips multiple @change="getSublocation(city,ques)">
                        <template slot="item" slot-scope="data">
                          <template>
                            <v-list-item-content>{{data.item.text}}</v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete class="mt-5" v-model="answers" :items="ques.items" item-text="text" item-value="id" label="Select sublocation" clearable chips deletable-chips outlined v-if="subCity" @change="selectAnswer(answers,ques)" multiple>
                        <template slot="item" slot-scope="data">
                          <template>
                            <v-list-item-content>{{data.item.text}}</v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </div>
                    <div v-else>
                      <v-autocomplete v-model="ques.correct" :items="ques.items" item-text="text" item-value="id" clearable chips deletable-chips outlined @change="selectAnswer(ques.correct,ques)" multiple> 
                        <template slot="item" slot-scope="data">
                          <template>
                            <v-list-item-content>{{data.item.text}}</v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </div>
                  </div>
                  <v-checkbox class="screeningq" v-model="ques.deal_breaker" :true-value="1" :false-value="0" label="Screening question"></v-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="loader" v-if="loading">
              <PreLoader></PreLoader>
          </div>
          <div>
            <h6 class="mb-3"><strong>Add more questions</strong></h6>
            <div class="mt-2 qsttypebtns">
              <button class="btn btn-outline-primary mb-2 mr-2" :class="(type=='personal')?'active':''" v-on:click="(type=='personal')?(type=null):(type='personal')">Personal</button>
              <button class="btn btn-outline-primary mb-2 mr-2" :class="(type=='education')?'active':''" v-on:click="(type=='education')?(type=null):(type='education')">Education</button>
              <button class="btn btn-outline-primary mb-2 mr-2" :class="(type=='experience')?'active':''" v-on:click="(type=='experience')?(type=null):(type='experience')">Experience</button>
              <button class="btn btn-outline-primary mb-2 mr-2" :class="(type=='job-related')?'active':''" v-on:click="(type=='job-related')?(type=null):(type='job-related')">Job related </button>
              <button class="btn btn-outline-primary mb-2 mr-2" :class="(type=='other')?'active':''" v-on:click="(type=='other')?(type=null):(type='other')" v-if="type=='other'">Other</button>
              <button class="btn btn-outline-primary mb-2 mr-2" :class="(type=='custom')?'active':''" v-on:click="(type=='custom')?(type=null):(type='custom')">Add own question</button>
              <!-- <ul>
                <li class="btn btn-outline-info mb-2" style="display:block;" v-on:click="(type='personal')">Personal</li>
                <li class="btn btn-outline-info mb-2" style="display:block;" v-on:click="(type='education')">Education</li>
                <li class="btn btn-outline-info mb-2" style="display:block;" v-on:click="(type='experience')">Experience</li>
                <li class="btn btn-outline-info mb-2" style="display:block;" v-on:click="(type='job-related')">Job-related </li>
                <li class="btn btn-outline-info mb-2" style="display:block;" v-on:click="(type='other')">Other</li>
                <li class="btn btn-outline-info mb-2" style="display:block;" v-on:click="(type='custom')">Custom Question</li>
              </ul> -->
            </div>
          </div>
          <div class="mt-6 questiontyps" v-if="selectedQuestions.length < 50">
            <div class="pt-0" v-if="type == 'personal'">
              <div v-for="q in question_pool" :key="q.id">
                <div class="question" v-if="q.category == 1">
                  <v-checkbox style="margin-top:0px !important" v-model="selectedPoolQuestions" :label="q.question" color="primary" v-on:click.prevent="addQuestion(q)"  v-bind:value="q"></v-checkbox>
                </div>
              </div>
            </div>
            <div class="pt-0" v-if="type == 'education'">
                <div v-for="q in question_pool" :key="q.id">
                  <div class="question" v-if="q.category == 2">
                    <v-checkbox style="margin-top:0px !important" v-model="selectedPoolQuestions" :label="q.question" id:key color="primary" v-on:click="addQuestion(q)"  :value="q"></v-checkbox>
                  </div>
                </div>
            </div>
            <div class="pt-0" v-if="type == 'experience'">
                <div v-for="q in question_pool" :key="q.id">
                  <div class="question" v-if="q.category == 3">
                    <v-checkbox style="margin-top:0px !important" v-model="selectedPoolQuestions" :label="q.question" id:key color="primary" v-on:click="addQuestion(q)"  :value="q"></v-checkbox>
                  </div>
                </div>
            </div>
            <div class="pt-0" v-if="type == 'job-related'">
                <div v-for="q in question_pool" :key="q.id">
                  <div class="question" v-if="q.category == 4">
                    <v-checkbox style="margin-top:0px !important" v-model="selectedPoolQuestions" :label="q.question" id:key color="primary" v-on:click="addQuestion(q)"  :value="q"></v-checkbox>
                  </div>
                </div>
            </div>
            <div class="pt-0" v-if="type == 'other'">
                <div v-for="q in question_pool" :key="q.id">
                  <div class="question" v-if="q.category == 0">
                    <v-checkbox style="margin-top:0px !important" v-model="selectedPoolQuestions" :label="q.question" id:key color="primary" v-on:click="addQuestion(q)"  :value="q"></v-checkbox>
                  </div>
                </div>
            </div>
            <div v-if="type == 'custom'"><p style="font-size:12px;margin-top:5px;">Do not ask questions that are illegal, discriminatory & violate the general employment terms </p></div>
            <div class="pt-0" v-if="type == 'custom'">
              <v-form ref="form" lazy-validation v-model="valid">
                <div v-if="selectedQuestions.length < 50">
                  <label class="mt-6">Question No {{selectedQuestions.length+1}}</label>
                  <v-textarea id="question-title" type="text" rows="2" v-model="question.question" :rules="[v => !!v || 'Enter question']" placeholder="Enter your question here" outlined></v-textarea>
                  <div class="row">
                    <div class="col-lg-6 mt-5">
                      <v-autocomplete v-model="question.question_type" :items="answer_type" item-value="id" item-text="text" :rules="[v => !!v || 'Select question type']" placeholder="Select answer type" outlined></v-autocomplete>
                    </div> 
                  </div>
                  <div class="row" v-if="question.question_type == 1 || question.question_type ==2">
                    <div class="col-lg-6">
                      <v-text-field type="text" class="mt-2" :label="(question.question_type==1)?'Short answer':'Long answer'" disabled></v-text-field>
                    </div>
                  </div>
                  <div class="row" v-if="question.question_type == 4">
                    <div class="col-lg-6">
                      <v-text-field type="text" class="mt-2" v-model="radio_ans.answer1" label="Ans. 1" outlined></v-text-field>
                      <v-text-field type="text" class="mt-5" v-model="radio_ans.answer2" label="Ans. 2" outlined></v-text-field>
                    </div>
                    <div class="col-lg-6">
                      <v-radio-group v-model="radio_ans.correct_answer_flag" label="Correct answer" row>
                        <v-radio label="Ans.1" :value='1'></v-radio>
                        <v-radio label="Ans.2" :value='2'></v-radio>
                      </v-radio-group>
                    </div>
                  </div>
                  <div class="row" v-if="question.question_type == 3">
                    <div class="col-lg-12"  v-for="(input,index) in check_options" :key="index">
                      <div class="row">
                        <div class="col-lg-11"><v-text-field @input="filterComma(index)" type="text" class="mt-2" v-model="checkbox_ans[index]" :label="input.option" outlined :disabled='input.option=="Other"?true:false'></v-text-field></div>
                        <div class="col-lg-1 mt-2" v-on:click="removeField(index)" style="font-size:30px;cursor:pointer;">x</div>
                      </div>
                    </div>
                    <div class="mt-0 col"><span v-on:click="addOptions" class="text-secondary" style="cursor:pointer">Add option</span><span v-if="check_other==false" class="text-primary"> or <span v-on:click="addOther" style="cursor:pointer">add "Other"</span></span></div>
                  </div>
                </div>
                <div class="row">
                  <div v-if="selectedQuestions.length < 50" class="col-lg-6">
                    <div class="col-lg-6 text-secondary" style="cursor:pointer"><span v-on:click.prevent="saveQuestions">Save and Add more</span></div>
                  </div>
                </div>
              </v-form>
            </div>
          </div>
          <div class="float-right qustbtns">
            <span role="button" v-on:click.prevent="skipQuestionnaire()">Skip</span>
            <button class="btn btn-primary ml-2" v-on:click.prevent="submitQuestionnaire()"><b>Save questionnaire</b></button>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="ques-success" ref="ques-success" size="sm" title=" " body-bg-variant="primary" bod body-text-variant="light" hide-footer hide-header hide-backdrop centered>
      <div class="container text-center">Saved</div>
    </b-modal>
    <b-modal id="ques-error" ref="ques-error" size="sm" title=" " body-bg-variant="danger" bod body-text-variant="light" hide-footer hide-header hide-backdrop centered>
      <div class="container text-center">Error</div>
    </b-modal>
  </div>
</template>

<script>
const PreLoader = () => import(/* webpackPrefetch: true */ "@/components/PreLoader");
export default {
  name: "questionnaire",
  components: {
    'PreLoader':PreLoader
  },
  data(){
    return {
      valid:false,
      question:{
        id:null,
        question:null,
        question_type:null,
        is_mandatory:0,
        question_flag:1,
        answers:[]
      },
      answer:{
        answer:'',
        correct_answer_flag:0
      },
      checkbox_ans:[],
      radio_ans:{
        answer1:'',
        answer2:'',
        correct_answer_flag:0
      },
      answer_type:[
        {id:1, text:'text'},
        {id:2, text:'paragraph'},
        {id:3, text:'checkbox'},
        {id:4, text:'radio'},
        {id:7, text:'video'}
      ],
      check_options:[{option:'Ans. 1'}],
      check_option:1,
      check_other:false,
      question_pool:[],
      questionnaire:{
        job_id:null,
        client_user_id:null,
        company_id:null,
        questions:[]
      },
      selectedQuestions:[],
      requests:[],
      selectedPoolQuestions:[],
      submitForm:true,
      pool_question:{},
      selected_flag:false,
      questionnaire_questions:[],
      type:null,
      job_role:null,
      version:null,
      user_id:null,
      job:null,
      selected:false,
      loading:true,
      items:[],
      multiple:false,
      answers:[],
      autocomplete: false,
      cities:[],
      city:[],
      subCity:false,
      showDismissibleAlert:false,
      succuss_msg:'',
      showDropDown: [],
      dropdown: "",
    }
  },
  async beforeMount(){
    window.scrollTo(0, 0);
    if(Object.keys(this.$route.params).length && this.$route.params.status){
      this.showDismissibleAlert = true;
      this.succuss_msg = this.$route.params.succuss;
      this.job_id = this.$route.params.job_id;
    }else{
      this.showDismissibleAlert = false;
    }  
    let token = this.$cookies.get("hire-employer").token;
    this.job_id = parseInt(this.$route.params.id);
    this.job_role = this.$route.query.role?parseInt(this.$route.query.role):null;
    this.version = this.$route.query.version;
    this.user_id = parseInt(this.$route.query.user);
    await new this.$apiAction().getJobDetails({id:this.job_id,type:this.version, user_id:this.user_id}).then(res => {
      this.job = res.data;
    });
    
    await new this.$apiAction().getQuestionsFromPool(this.job_role,token).then(questions => {
      questions.forEach(data =>{
        let answers=[];
        this.pool_question = {};
          data.question = data.question.replace('[15000 - 25000 Per Month]',this.job.jobs?.salary_range_from+((this.job.jobs.salary_range_to)?'-'+this.job.jobs.salary_range_to:'')+' Per Month')
          data.question = data.question.replace('{location}', this.job.cities.join(','));
          data.question = data.question.replace('{jobposition}', this.job.jobs.job_designation);
          data.question = data.question.replace('{company}', this.job.jobs.company_name);
        if(data.answers&&data.answers.length){
          data.answers.forEach(ans => {
            answers.push({ans_id:ans.ans_id,answer:ans.answer, correct_answer_flag:ans.correct_answer_flag})
          })
        }
        if(this.selectedQuestions.length > 0){
          this.selectedQuestions.forEach(q =>{
            this.pool_question = {qp_id:data.qid,question_flag:data.status,client_user_id:this.user_id,job_id:this.job_id,correct:null,question_type:data.question_type,question:data.question,category:data.category,is_mandatory:0,deal_breaker:0,answers:answers};
            if(q.question == data.question){
              this.selectedPoolQuestions.push(this.pool_question);
            }
          })
        }else{
          this.pool_question = {qp_id:data.qid,question_flag:data.status,client_user_id:this.user_id,job_id:this.job_id,correct:null,question_type:data.question_type,question:data.question,is_mandatory:0,category:data.category,deal_breaker:0,answers:[]}
        }

        answers.forEach(ans => {
          if(ans.correct_answer_flag == 1){
            this.pool_question.correct = ans.ans_id;
          }
        });
        this.pool_question.answers = answers;
        this.setAnswer(this.pool_question);
        this.question_pool.push(this.pool_question);
      });
    });

    this.getQuestionnaire(this.job_id);
  },
  methods: {
    showDeleteConfirmation(qid, i, msg = 'Are you sure you want to delete this question?') {
        this.$bvModal.msgBoxConfirm(msg, {
            buttonSize: 'sm',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
        })
        .then((res) => {
            if(res){
                this.deleteQuesFromQuestionnaire(qid, i);
            }
        });
    },
    deleteQuesFromQuestionnaire(qid, i){
      console.log(qid)
      if(qid) {
        let token = this.$cookies.get("hire-employer").token;
        new this.$apiAction().deleteQuesFromQuestionnaire(this.job_id,qid,token).then(res => {
          if(res.error == 0){
            this.questionnaire_questions = this.questionnaire_questions.filter(q => q.qid !== qid);
            this.selectedQuestions = this.selectedQuestions.filter(q => q.qid !== qid);
            this.requests = this.requests.filter(q => q.qid !== qid)
          }
        })
      } else {
        this.selectedQuestions.splice(i, 1);
        this.requests.splice(i, 1);
      }
    },
    filterComma(index) {
      this.checkbox_ans[index] = this.checkbox_ans[index].replace(/,/g, '');
    },
    async getQuestionnaire(id){
      let token = this.$cookies.get("hire-employer").token;
      await new this.$apiAction().getQuestionnaire(id,token).then(res => {
        if(res.questionnaire.length){
          res.questionnaire.forEach(q => {
            q.correct = null;
            if(q.answers && q.answers.length){
              q.answers.forEach(ans => {
                if(ans.correct_answer_flag == 1){
                  q.correct = ans.ans_id;
                }
              });
            }
            if(q.question_type == 5 && q.qp_id != null){
              this.setAnswer(q);
            }
            q.show = false;
            this.questionnaire_questions.push(q);
            this.selectedQuestions.push(q);
            this.requests.push(q);
            if(q.qp_id){
              this.question_pool.forEach(qp => {
                if(qp.qp_id == q.qp_id){
                  this.selectedPoolQuestions.push(qp);
                }
              });
            }
            this.loading = false;
          })
        }else{
          this.selectedQuestions=[];
          this.requests = [];
          this.question_pool.forEach(q =>{
            if(q.qp_id == 3 || q.qp_id == 23){
              this.selectedQuestions.push(q);
              this.requests.push(q);
              this.selectedPoolQuestions.push(q);
            }
          })
          this.loading = false;
        }
      })
    },
    async setAnswer(question){
      question.items = [];
      question.correct = [];
      if(question.question_type == 5){
        question.autocomplete = false;
        if(question.qp_id == 2){
          new this.$apiAction().getJobrole().then(res => {
            res.jobroles.forEach(role => {
              question.items.push({value:role.role_id,text:role.role});
            });
          });
          if(question.answers&&question.answers.length){
            question.answers.forEach(ans => {
              if(ans.answer){
                question.correct.push(parseInt(ans.answer));
              }
            })
          }
        }else if(question.qp_id == 4 || question.qp_id == 23 || question.qp_id == 5){
          question.autocomplete = true;
          await new this.$apiAction().getStates().then(async (data) => {
            question.items = [];
            if(question.qp_id == 5){
              this.cities.push({header: 'Top Metropolitan Cities'});
            }else{
              question.items.push({header: 'Top Metropolitan Cities'})
            }
            await data.states.forEach(async (element) => {
              await element.cities.forEach(city => {
                if(city.top_city == 1){
                  if(question.qp_id == 5){
                    this.cities.push({text:city.city_name,id:city.city_id, s_id:city.state_id,group:'Top Metropolitan Cities'});
                  }else{
                    question.items.push({text:city.city_name,id:city.city_id, s_id:city.state_id,group:'Top Metropolitan Cities'})
                  }
                }
              });
              question.items.push({divider:true})
              question.items.push({header: element.state_name});
              element.cities.forEach(city => {
                if(city.top_city == 0){
                  if(question.qp_id == 5){
                    this.cities.push({text:city.city_name,id:city.city_id, s_id:city.state_id,group:element.state_name})
                  }else{
                    question.items.push({text:city.city_name,id:city.city_id, s_id:city.state_id,group:element.state_name})
                  }
                }
              });
            });
            question.items.push({text:'Anywhere india',id:5000,s_id:36,group:'Anywhere india'})
          });
          if(question.answers&&question.answers.length){
            question.answers.forEach(ans => {
              if(ans.answer){
                question.correct.push(parseInt(ans.answer));
              }
            })
          }
        }else if(question.qp_id == 8){
          new this.$apiAction().getSkills().then((data) => {
            data.skills.forEach((element) => {
              question.items.push({
                value: element.id,
                text: element.skill,
                slug: element.slug
              })
            })
          });
          if(question.answers&&question.answers.length){
            question.answers.forEach(ans => {
              if(ans.answer){
                question.correct.push(parseInt(ans.answer));
              }
            });
          }
        }else if(question.qp_id == 21){
          question.autocomplete = false;
          question.items = [
                            { value : 1, text: "0 Month(Fresher)" },
                            { value : 6, text: "06 Months" },
                            { value : 12, text: "1 Year" },
                            { value : 24, text: "2 year" },
                            { value : 36, text: "3 year" },
                            { value : 48, text: "4 year" },
                            { value : 60, text: "5 year" },
                            { value : 72, text: "6 year" },
                            { value : 84, text: "6+ year" },
                          ];
            if(question.answers&&question.answers.length){
            question.answers.forEach(ans => {
              if(ans.answer){
                question.correct.push(parseInt(ans.answer));
              }
            });
          }
        }else if(question.qp_id == 7){
          new this.$apiAction().getLanguages().then(data => {
            data.languages.forEach((element) => {
              question.items.push({
                value:element.id,
                text:element.language
              });
            });
          });
          if(question.answers&&question.answers.length){
            question.answers.forEach(answer => {
              if(parseInt(answer.answer)){
                question.correct.push(parseInt(answer.answer));
              }
            });
          }
        }else if(question.qp_id == 22){
          new this.$apiAction().getJobDesignations().then(res => {
            res.jobdesignations.forEach((e)=>{
              question.items.push({
                value : e.designation_id,
                text : e.designation,
                role_id : e.role_id
              })
            })
          });
          if(question.answers&&question.answers.length){
            question.answers.forEach(ans => {
              if(ans.answer){
                question.correct.push(parseInt(ans.answer));
              }
            })
          }
        }else if(question.qp_id == 15){
          question.autocomplete = true;
          await new this.$apiAction().getCourse().then(async (data) => {
            question.items.push({header: 'Popular Courses'})
            await data.courses.forEach((element) => {  
              if((element.popular_rating == 1&&element.course_id<=5001 && element.course_id != 37)||(element.popular_rating == 1 &&element.course_id == 5013)){
                question.items.push({text:element.course_name,id:element.course_id,group:'Popular Courses'})
              }
            });
            question.items.push({divider:true})
            question.items.push({header: 'PG Courses'});   
            await data.courses.forEach((element) => {  
              if((element.popular_rating == 0 && element.course_type == 'pg'&&element.course_id<=5001 && element.course_id != 37) || (element.popular_rating == 0 && element.course_type == 'pg'&&element.course_id == 5013)){
                question.items.push({text:element.course_name,id:element.course_id,group:'PG Courses'})
              }
            });
            question.items.push({divider:true})
            question.items.push({header: 'Graduation Courses'});   
            await data.courses.forEach((element) => {  
              if((element.popular_rating == 0 && element.course_type == 'graduation'&&element.course_id<=5001 && element.course_id != 37) || (element.popular_rating == 0 && element.course_type == 'graduation'&&element.course_id == 5013)){
                question.items.push({text:element.course_name,id:element.course_id,group:'Graduation Courses'})
              }
            });
            question.items.push({divider:true})
            question.items.push({header: 'Other Category'});   
            await data.courses.forEach((element) => {  
              if((element.popular_rating == 0 && element.course_type == 'others_category'&&element.course_id<=5001 && element.course_id != 37) || (element.popular_rating == 0 && element.course_type == 'others_category'&&element.course_id == 5013)){
                question.items.push({text:element.course_name,id:element.course_id,group:'Other Category'})
              }
            });
          });
          if(question.answers&&question.answers.length){
            question.answers.forEach(ans => {
              if(ans.answer){
                question.correct.push(parseInt(ans.answer));
              }
            })
          }
        }else{
          question.items = [];
        }
      }
    },
    getSublocation(answers,question){
      question.items = [];
      answers.forEach(answer => {
        this.getSubCities(answer,question)
      });
    },
    getSubCities: function (city_id,question) {
        var check = true;
        new this.$apiAction().getSubcity(city_id).then((data) => {
          if(data.sublocations){
            this.subCity = true;
            data.sublocations.forEach((element) => {
              if(check == true){
                question.items.push({
                  header: element.city_name
                })
                check = false;
              }else{
                question.items.push({
                  value: element.sublocation_id,
                  text: element.sublocation_name,
                  city_id:city_id
                });  
              }
            });
          }else if(question.items.length){
            this.subCity = true;
          }else{
            this.subCity = false;
          }
        });
    },
    addQuestion(q){
      if(this.selectedPoolQuestions.length > 0){
        if(this.selectedPoolQuestions.includes(q)){
          this.requests.push(this.selectedPoolQuestions[this.selectedPoolQuestions.length-1]);
          this.selectedPoolQuestions[this.selectedPoolQuestions.length-1].deal_breaker = 0;
          this.selectedPoolQuestions[this.selectedPoolQuestions.length-1].question_flag = 1;
          this.selectedPoolQuestions[this.selectedPoolQuestions.length-1].show = true;
          this.selectedQuestions.push(this.selectedPoolQuestions[this.selectedPoolQuestions.length-1]);
        }else{
          this.selectedQuestions=this.selectedQuestions.filter((item) => item.qp_id !== q.qp_id);
          this.requests=this.requests.filter((item) => item.qp_id !== q.qp_id);
        }
      }
    },
    deleteQuestion(index){
      let data = this.selectedQuestions[index];
      if(this.selectedPoolQuestions.length){
        this.selectedPoolQuestions.some((ques,index) => {
          if(ques.question === data.question){
            this.selectedPoolQuestions.splice(index,1) ;
          }
        });
      }

      this.selectedQuestions.splice(index,1) ;
      this.requests.splice(index,1);
    },
    selectAnswer(answers,question){
      question.answers = [];
      answers.forEach(answer=>{
        question.answers.push({answer:answer,correct_answer_flag:1});
      });
    },
    saveQuestions(){
      // e.preventDefault();
      this.question.job_id = this.job_id;
      this.question.client_user_id = this.user_id;
      this.question.deal_breaker = 0;
      this.question.question_flag = 1;
      this.question.qp_id = this.question.qp_id?this.question.qp_id:null;
      // this.checkbox_ans = [];
      this.valid = this.$refs.form.validate();
      if(this.valid == true){
        if(this.question.question_type == 4){
          this.setRadioAnswers();
        }else if(this.question.question_type == 3){
          this.setCheckboxAnswers();
        }else{
          this.selectedQuestions.push(this.cloneValue(this.question));
          this.requests.push(this.cloneValue(this.question));
          this.resetQuestion();
          // this.valid= false;
        }
      }
    },

    submitQuestionnaire(){
      if(this.question.question) this.saveQuestions();
      
      if(this.selectedQuestions.length > 0){
        new this.$apiAction().addQuestionnaire(this.requests, this.$cookies.get("hire-employer").token).then(res => {
          if(res.message == 'Question Added Succussfully'){
            // this.$refs["ques-success"].show();
            setTimeout(() => {
              // this.$refs["ques-success"].hide();
              // this.$router.push('/recruit/client-job-dashboard');
              this.$router.push({name:'recruiter_dashboard',params:{'status':true,success:'Questionnaire added to the job.'}});
            },2000)
          }else{
            this.$refs["ques-error"].show();
            setTimeout(() => {
              this.$refs["ques-error"].hide();
            },2000)
          }
        })
      }else{
        this.$refs["ques-error"].show();
        setTimeout(() => {
          this.$refs["ques-error"].hide();
        },2000)
      }
    },
    isLastItemEmpty(){
      return !this.checkbox_ans[this.check_options.length -  1] ?  true : false
    },
    addOptions(e){
      e.preventDefault();
      console.log(this.isLastItemEmpty())
      if(!this.isLastItemEmpty(this.checkbox_ans)) {
        this.check_option++;
        if(this.check_other == false){
          this.check_options.push({option:'Ans. '+this.check_option})
        }else{
          this.check_options.splice(this.check_options.length-1,0,{option:'Ans. '+(this.check_option-1)})
        }
      }
    },
    addOther(e){
      e.preventDefault();
      this.check_option++;
      this.check_other = true;
      this.check_options.push({option:'Other'});
    },
    removeField(index){
      this.check_options.splice(index,1);
    },
    cloneValue(data) {
      var clone = {};
      for (var key in data) {
        if (Object.prototype.hasOwnProperty.call(data,key)) //ensure not adding inherited props
          clone[key] = data[key];
        }
      return clone;
    },
    setRadioAnswers(){
      console.log(this.radio_ans.correct_answer_flag);
      let ans1 = {ans_id:1,answer:this.radio_ans.answer1,correct_answer_flag: (this.radio_ans.correct_answer_flag==1)?1:0};
      let ans2 = {ans_id:2,answer:this.radio_ans.answer2,correct_answer_flag: (this.radio_ans.correct_answer_flag==2)?1:0};
      this.question.correct = this.radio_ans.correct_answer_flag;
      this.question.answers.push(this.cloneValue(ans1),this.cloneValue(ans2));
      this.selectedQuestions.push(this.cloneValue(this.question));
      this.requests.push(this.cloneValue(this.question));
      this.resetQuestion();
    },
    setCheckboxAnswers(){
      this.checkbox_ans.forEach(check_ans => {
        let ans = {answer:check_ans,correct_answer_flag : 0};
        this.question.answers.push(this.cloneValue(ans));
      })
      if(this.check_other == true){
        this.question.answers.push(this.cloneValue({answer:'Other', correct_answer_flag:0}))
      }
      this.selectedQuestions.push(this.cloneValue(this.question));
      this.requests.push(this.cloneValue(this.question));
      this.resetQuestion();
    },
    resetQuestion(){
      this.question.question = null;
      this.question.question_type = null;
      this.question.is_mandatory = 0;
      this.question.answers = [];
      this.checkbox_ans = [];
      this.check_option = 1;
      this.check_options = [{option:'Ans. 1'}]
      this.$refs.form.resetValidation()
    },
    skipQuestionnaire(){
      this.$router.push('/recruit/client-job-dashboard');
    },
    showDropDownList(i) {
      this.dropdown = this.dropdown == "" ? "show_drop_list_" + i : "";
    },
    showDropDownDetails(e) {
      e.preventDefault();
      console.log(this);
    },
  }
}
</script>

<style scoped>
.v-input {
  flex: none !important;
}
.row{
  flex: none !important;
}
.dropdown_more {
  background-color: #f8f9fa;
  border: 1px solid #efeeee;
  position: absolute;
  width: 60px;
  text-align: center;
  margin:0;
}
.dropdown-content:hover {
  background-color: #f0f1f1;
}

</style>